import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { M150ExportComponent } from './m150-export.component';
import { M150ExportService } from './m150-export.service';
import { SettingSelectionPageComponent } from './pages/setting-selection-page/setting-selection-page.component';
import { WizardExportModule } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { ExportModeSelectionPageComponent } from './pages/export-mode-selection-page/export-mode-selection-page.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [M150ExportComponent, SettingSelectionPageComponent, ExportModeSelectionPageComponent],
  imports: [
    CommonModule,
    AbcUiComponentsModule,
    MatButtonModule,
    WizardExportModule,
    MatRadioModule,
    MatIconModule,
    MatButtonToggleModule,
  ],
  providers: [M150ExportService, provideHttpClient(withInterceptorsFromDi())],
})
export class M150ExportModule {}
